import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  SetBlockUiType = '[STORE | CONTROL | HISTORY] Set Block Ui Type',
  GetEntitySuccess = '[STORE | CONTROL | HISTORY] Get Entity Success',
  GetEntitiesSuccess = '[STORE | CONTROL | HISTORY] Get Entities Success',
  ModifyEntitySuccess = '[STORE | CONTROL | HISTORY] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | CONTROL | HISTORY] Modify Entities Success',
  FinishSnapshot = '[STORE | CONTROL | HISTORY] Finish Snapshot',
  UndoSnapshot = '[STORE | CONTROL | HISTORY] Undo Snapshot',
  RedoSnapshot = '[STORE | CONTROL | HISTORY] Redo Snapshot',
  SaveSnapshots = '[STORE | CONTROL | HISTORY] Save Snapshots',
  SaveSnapshotsSuccess = '[STORE | CONTROL | HISTORY] Save Snapshots Success',
  SaveSnapshotsFailure = '[STORE | CONTROL | HISTORY] Save Snapshots Failure',
  ClearHistoryForEntity = '[STORE | CONTROL | HISTORY] Clear History For Entity',
  ClearHistoryForEntities = '[STORE | CONTROL | HISTORY] Clear History For Entities',
  /**
   * Request
   */
  SaveSnapshotsRequest = '[REQUEST | CONTROL | HISTORY] Save Snapshots Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Set Block Ui Type
 */
export class SetBlockUiType {
  public static readonly type = ActionTypes.SetBlockUiType;

  public constructor(public blockUiType: FlatModels.EntityControlModels.BlockUiType) {
  }
}

/**
 * Get Entity Success
 */
export class GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;

  public constructor(public entityQueryResult: FlatModels.EntityControlModels.EntityQueryResult) {
  }
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;

  public constructor(public entityQueryResults: FlatModels.EntityControlModels.EntityQueryResult[]) {
  }
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;

  public constructor(public entityModifyResult: FlatModels.EntityControlModels.SaveSnapshotItem) {
  }
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;

  public constructor(public entityModifyResults: FlatModels.EntityControlModels.SaveSnapshotItem[]) {
  }
}

/**
 * Finish Snapshot
 */
export class FinishSnapshot {
  public static readonly type = ActionTypes.FinishSnapshot;

  public constructor(public name: string,
                     public url: string,
                     public fromUrl?: string) {
  }
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Save Snapshots
 */
export class SaveSnapshots {
  public static readonly type = ActionTypes.SaveSnapshots;
}

/**
 * Save Snapshots Success
 */
export class SaveSnapshotsSuccess {
  public static readonly type = ActionTypes.SaveSnapshotsSuccess;

  public constructor(public entityModifyResults: FlatModels.EntityControlModels.SaveSnapshotItem[]) {
  }
}

/**
 * Save Snapshots Failure
 */
export class SaveSnapshotsFailure {
  public static readonly type = ActionTypes.SaveSnapshotsFailure;
}

/**
 * Clear History For Entity
 */
export class ClearHistoryForEntity {
  public static readonly type = ActionTypes.ClearHistoryForEntity;

  public constructor(public saveSnapshotItem: FlatModels.EntityControlModels.SaveSnapshotItem) {
  }
}

/**
 * Clear History For Entities
 */
export class ClearHistoryForEntities {
  public static readonly type = ActionTypes.ClearHistoryForEntities;

  public constructor(public saveSnapshotItems: FlatModels.EntityControlModels.SaveSnapshotItem[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Save Snapshots Request
 */
export class SaveSnapshotsRequest {
  public static readonly type = ActionTypes.SaveSnapshotsRequest;

  public constructor(public saveSnapshotItems: FlatModels.EntityControlModels.SaveSnapshotItem[]) {
  }
}

// </editor-fold>
